import React, { useEffect, useState } from 'react';
import Header from './Header';
import { useApp } from '../context/AppContext';

const PageLayout = ({ 
  children,
  className = ""
}) => {
  const { loading } = useApp();
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <div className="min-h-full h-full dark bg-background">
      <Header onCartClick={() => setIsCartOpen(true)} />
      <main>
        {loading ? (
          <div className="flex h-screen items-center justify-center">
            <div className="text-lg text-foreground">Loading...</div>
          </div>
        ) : (
          <div className="flex h-full bg-background text-foreground overflow-hidden">
            {/* Main Content Area */}
            <div className="flex-1 flex h-full">
              <div className={`flex-1 ${className}`}>
                {children}
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default PageLayout;
